import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { User, FormSubmissionPayload } from 'types';

import { apiQuery } from '../../query';

import {
  ProfileFormData,
  ProfileFormResponse,
  ProfileDetailsResponse,
} from './types';

const profileTagType = 'PROFILE';
const formTagType = 'PROFILE_FORM';
const tagTypes = [profileTagType, formTagType];

export const authApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'authApi',
  endpoints: (build) => ({
    form: build.query<ProfileFormData, void>({
      providesTags: [formTagType],
      transformResponse: (response: ProfileFormResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.PROFILE_FORM,
      }),
    }),

    details: build.query<User, void>({
      providesTags: [profileTagType],
      transformResponse: (response: ProfileDetailsResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.PROFILE_DETAILS,
      }),
    }),

    update: build.mutation<
      ProfileDetailsResponse,
      Pick<User, 'lastName' | 'firstName'>
    >({
      query: (data) => ({
        data,
        method: 'patch',
        url: URL.PROFILE_DETAILS,
      }),
      invalidatesTags: (result, error) => {
        if (error) return [];
        return [profileTagType];
      },
    }),

    submitForm: build.mutation<void, FormSubmissionPayload>({
      invalidatesTags: (result, error) => {
        if (error) return [];
        return [profileTagType, formTagType];
      },
      query: (data) => {
        const { formId, ...payload } = data;
        return {
          data: payload,
          method: 'patch',
          url: URL.PROFILE_FORM_SUBMIT.replace(':id', formId),
        };
      },
    }),
  }),
});

export const {
  useFormQuery,
  useDetailsQuery,
  useUpdateMutation,
  useSubmitFormMutation,
} = authApi;
